import { ref, onMounted, onUnmounted } from "vue";
import { useRouter } from "vue-router";

const open = ref(false);
const menuKeys = ref<Record<number, boolean>>({});

export const useSidebar = () => {
  const router = useRouter();

  const toggleFixed = () => {
    open.value = !open.value;
    menuKeys.value = {};
  };

  const closeSidebar = () => {
    open.value = false;
    menuKeys.value = {};
  };

  const toggleMenu = (key: number) => {
    menuKeys.value[key] = !menuKeys.value[key];
  };

  const isOpen = (key: number) => !!menuKeys.value[key];

  const handleClickOutside = (event: MouseEvent) => {
    const sidebar = document.querySelector("aside");
    const button = document.querySelector("button");

    if (
      open.value &&
      sidebar &&
      !sidebar.contains(event.target as Node) &&
      button &&
      !button.contains(event.target as Node)
    ) {
      closeSidebar();
    }
  };

  onMounted(() => {
    document.addEventListener("click", handleClickOutside, true);

    router.afterEach(() => {
      closeSidebar();
    });
  });

  onUnmounted(() => {
    document.removeEventListener("click", handleClickOutside, true);
  });

  return {
    open,
    toggleFixed,
    closeSidebar,
    toggleMenu,
    isOpen,
  };
};
